import React from 'react';
import EventButton from '../../../atoms/EventButton/EventButton';

export default ({ orientation, onToggle, currentIndex }) => (
  <EventButton
    event={{
      category: 'Image-Collection',
      action: 'Click',
      label: orientation,
    }}
    secondary
    circular
    icon={`angle ${orientation}`}
    onClick={() => onToggle(currentIndex + (orientation === 'right' ? 1 : -1))}
    className="ic-carousel-arrow"
    style={{
      ...(orientation === 'right' ? { right: -15 } : { left: -15 }),
    }}
  />
);
